module.exports = __webpack_public_path__ + "img/languages.aa62d6c2.svg";